"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommission = exports.getValidators = exports.getStakingPositions = exports.broadcastTransaction = exports.getAccessKey = exports.getGasPrice = exports.getProtocolConfig = exports.getAccount = exports.fetchAccountDetails = void 0;
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const bignumber_js_1 = require("bignumber.js");
const nearAPI = __importStar(require("near-api-js"));
const live_env_1 = require("@ledgerhq/live-env");
const logic_1 = require("../logic");
const preload_1 = require("../preload");
const index_1 = require("./index");
const constants_1 = require("../constants");
const fetchAccountDetails = (address) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield (0, network_1.default)({
        method: "POST",
        url: (0, live_env_1.getEnv)("API_NEAR_ARCHIVE_NODE"),
        data: {
            jsonrpc: "2.0",
            id: "id",
            method: "query",
            params: {
                request_type: "view_account",
                finality: "final",
                account_id: address,
            },
        },
    });
    return data.result;
});
exports.fetchAccountDetails = fetchAccountDetails;
const getAccount = (address) => __awaiter(void 0, void 0, void 0, function* () {
    let accountDetails;
    accountDetails = yield (0, exports.fetchAccountDetails)(address);
    if (!accountDetails) {
        accountDetails = {
            amount: "0",
            block_height: 0,
            storage_usage: 0,
        };
    }
    const { stakingPositions, totalStaked, totalAvailable, totalPending } = yield (0, exports.getStakingPositions)(address);
    const { storageCost } = (0, preload_1.getCurrentNearPreloadData)();
    const balance = new bignumber_js_1.BigNumber(accountDetails.amount);
    const storageUsage = storageCost.multipliedBy(accountDetails.storage_usage);
    const minBalanceBuffer = new bignumber_js_1.BigNumber(constants_1.MIN_ACCOUNT_BALANCE_BUFFER);
    let spendableBalance = balance.minus(storageUsage).minus(minBalanceBuffer);
    if (spendableBalance.lt(0)) {
        spendableBalance = new bignumber_js_1.BigNumber(0);
    }
    return {
        blockHeight: accountDetails.block_height,
        balance: balance.plus(totalStaked).plus(totalAvailable).plus(totalPending),
        spendableBalance,
        nearResources: {
            stakedBalance: totalStaked,
            availableBalance: totalAvailable,
            pendingBalance: totalPending,
            storageUsageBalance: storageUsage.plus(minBalanceBuffer),
            stakingPositions,
        },
    };
});
exports.getAccount = getAccount;
const getProtocolConfig = () => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield (0, network_1.default)({
        method: "POST",
        url: (0, live_env_1.getEnv)("API_NEAR_ARCHIVE_NODE"),
        data: {
            jsonrpc: "2.0",
            id: "id",
            method: "EXPERIMENTAL_protocol_config",
            params: {
                finality: "final",
            },
        },
    });
    return data.result;
});
exports.getProtocolConfig = getProtocolConfig;
const getGasPrice = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { data } = yield (0, network_1.default)({
        method: "POST",
        url: (0, live_env_1.getEnv)("API_NEAR_ARCHIVE_NODE"),
        data: {
            jsonrpc: "2.0",
            id: "id",
            method: "gas_price",
            params: [null],
        },
    });
    return (_a = data === null || data === void 0 ? void 0 : data.result) === null || _a === void 0 ? void 0 : _a.gas_price;
});
exports.getGasPrice = getGasPrice;
const getAccessKey = ({ address, publicKey, }) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield (0, network_1.default)({
        method: "POST",
        url: (0, live_env_1.getEnv)("API_NEAR_ARCHIVE_NODE"),
        data: {
            jsonrpc: "2.0",
            id: "id",
            method: "query",
            params: {
                request_type: "view_access_key",
                finality: "final",
                account_id: address,
                public_key: publicKey,
            },
        },
    });
    return data.result || {};
});
exports.getAccessKey = getAccessKey;
const broadcastTransaction = (transaction) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield (0, network_1.default)({
        method: "POST",
        url: (0, live_env_1.getEnv)("API_NEAR_ARCHIVE_NODE"),
        data: {
            jsonrpc: "2.0",
            id: "id",
            method: "broadcast_tx_async",
            params: [transaction],
        },
    });
    return data.result;
});
exports.broadcastTransaction = broadcastTransaction;
const getStakingPositions = (address) => __awaiter(void 0, void 0, void 0, function* () {
    const stakingDeposits = yield (0, index_1.getStakingDeposits)(address);
    const { connect, keyStores } = nearAPI;
    const config = {
        networkId: "mainnet",
        keyStore: new keyStores.InMemoryKeyStore(),
        nodeUrl: (0, live_env_1.getEnv)("API_NEAR_ARCHIVE_NODE"),
        headers: {},
    };
    const near = yield connect(config);
    const account = yield near.account(address);
    let totalStaked = new bignumber_js_1.BigNumber(0);
    let totalAvailable = new bignumber_js_1.BigNumber(0);
    let totalPending = new bignumber_js_1.BigNumber(0);
    const stakingPositions = yield Promise.all(stakingDeposits.map(({ validator_id: validatorId, deposit }) => __awaiter(void 0, void 0, void 0, function* () {
        const contract = new nearAPI.Contract(account, validatorId, {
            viewMethods: [
                "get_account_staked_balance",
                "get_account_unstaked_balance",
                "is_account_unstaked_balance_available",
                "get_account_total_balance",
            ],
            changeMethods: [],
        });
        const rawStaked = yield contract.get_account_staked_balance({
            account_id: address,
        });
        const rawUnstaked = yield contract.get_account_unstaked_balance({
            account_id: address,
        });
        const isAvailable = yield contract.is_account_unstaked_balance_available({
            account_id: address,
        });
        const rawTotal = yield contract.get_account_total_balance({
            account_id: address,
        });
        const unstaked = new bignumber_js_1.BigNumber(rawUnstaked);
        let available = new bignumber_js_1.BigNumber(0);
        let pending = unstaked;
        if (isAvailable) {
            available = unstaked;
            pending = new bignumber_js_1.BigNumber(0);
        }
        let rewards = new bignumber_js_1.BigNumber(0);
        const staked = new bignumber_js_1.BigNumber(rawStaked);
        available = new bignumber_js_1.BigNumber(available);
        pending = new bignumber_js_1.BigNumber(pending);
        rewards = new bignumber_js_1.BigNumber(rawTotal).minus(deposit);
        const stakingThreshold = (0, logic_1.getYoctoThreshold)();
        if (staked.gte(stakingThreshold)) {
            totalStaked = totalStaked.plus(staked);
        }
        if (available.gte(stakingThreshold)) {
            totalAvailable = totalAvailable.plus(available);
        }
        if (pending.gte(stakingThreshold)) {
            totalPending = totalPending.plus(pending);
        }
        return {
            staked,
            available,
            pending,
            rewards: rewards.gt(0) ? rewards : new bignumber_js_1.BigNumber(0),
            validatorId,
        };
    })));
    return {
        stakingPositions: stakingPositions.filter(sp => (0, logic_1.canUnstake)(sp) || (0, logic_1.canWithdraw)(sp) || sp.pending.gt(0)),
        totalStaked,
        totalAvailable,
        totalPending,
    };
});
exports.getStakingPositions = getStakingPositions;
const getValidators = () => __awaiter(void 0, void 0, void 0, function* () {
    var _b;
    const { data } = yield (0, network_1.default)({
        method: "POST",
        url: (0, live_env_1.getEnv)("API_NEAR_ARCHIVE_NODE"),
        data: {
            jsonrpc: "2.0",
            id: "id",
            method: "validators",
            params: [null],
        },
    });
    return ((_b = data === null || data === void 0 ? void 0 : data.result) === null || _b === void 0 ? void 0 : _b.current_validators) || [];
});
exports.getValidators = getValidators;
const getCommission = (address) => __awaiter(void 0, void 0, void 0, function* () {
    var _c;
    const { data } = yield (0, network_1.default)({
        method: "POST",
        url: (0, live_env_1.getEnv)("API_NEAR_ARCHIVE_NODE"),
        data: {
            jsonrpc: "2.0",
            id: "id",
            method: "query",
            params: {
                request_type: "call_function",
                account_id: address,
                method_name: "get_reward_fee_fraction",
                args_base64: "e30=",
                finality: "optimistic",
            },
        },
    });
    const result = (_c = data === null || data === void 0 ? void 0 : data.result) === null || _c === void 0 ? void 0 : _c.result;
    if (Array.isArray(result) && result.length) {
        const parsedResult = JSON.parse(Buffer.from(result).toString());
        return Math.round((parsedResult.numerator / parsedResult.denominator) * 100);
    }
    return null;
});
exports.getCommission = getCommission;
//# sourceMappingURL=archive-node-sdk.js.map